import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Trans, useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// import './index.scss';

export default function LanguageSwitcher({ selectedLanguageProp, setSelectedLanguage, prefix = '', variant = 'default'}) {
  const retailer = useSelector(state => state.retailer);

  const languages = [
    {
      "code": "en-US",
      "name": "English"
    },
    {
      "code": "fr-FR",
      "name": "French"
    },
    {
      "code": "es-ES",
      "name": "Spanish"
    },
    {
      "code": "zh-CN",
      "name": "Chinese"
    },
    {
      "code": "tl",
      "name": "Tagalog"
    },
  ];

  const selectedLanguage = selectedLanguageProp;

  const handleListItemClick = (language) => {
    if (setSelectedLanguage) {
      setSelectedLanguage(language);
    }
  };

  const defaultLanguageSwitcher = (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
      sx={{
        background: '#efeeee',
        height: '32px',
        py: 0.5,
        px: 5,
        mx: -5,
      }}
    >
      {
        !!selectedLanguage &&
        <>
          <Typography
            component={'div'}
            sx={{
              flexGrow: 1,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              px: 1,
            }}
          >
            {prefix} <strong>{selectedLanguage.name}</strong>
          </Typography>

          {
            languages.map((languageOption) => (
              <Box
                key={languageOption.code}
                sx={{
                  position: 'relative',
                  height: '32px',
                  width: '28px',
                  cursor: 'pointer',
                }}
                onClick={() => { handleListItemClick(languageOption); }}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  className=''
                  sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    background: '#fff',
                    borderBottom: (
                      selectedLanguage.code === languageOption.code ?
                        `4px solid ${retailer.button_background_color || 'red'}` :
                        '4px solid #fff'
                    ),
                    borderRadius: '0'
                  }}
                >
                  <Typography
                    sx={{
                      color: 'black',
                      fontSize: 16,
                      textTransform: 'uppercase',
                      fontWeight: selectedLanguage.code === languageOption.code ? 'bold' : 'normal',

                    }}
                  >
                    {languageOption.code.substring(0, 2)}
                  </Typography>
                </Stack>
              </Box>
            ))
          }
        </>
      }
    </Stack>
  );

  const compactLanguageSwitcher = (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
      sx={{
        background: 'transparent',
        height: '32px',
        my: 0.5,
        py: 0.5,
        px: 5,
        mx: -5,
      }}
    >
      {
        !!selectedLanguage &&
        <>
          {
            languages.map((languageOption) => (
              <Box
                key={languageOption.code}
                sx={{
                  position: 'relative',
                  height: selectedLanguage.code === languageOption.code ? '32px' : '26px',
                  width: selectedLanguage.code === languageOption.code ? '32px' : '26px',
                  cursor: 'pointer',
                }}
                onClick={() => { handleListItemClick(languageOption); }}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  className=''
                  sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    background: 'transparent',
                    borderRadius: '0.5rem',
                    border: (
                      selectedLanguage.code === languageOption.code ?
                        `2px solid ${retailer.button_background_color || 'red'}` :
                        '1px solid #fff'
                    ),
                  }}
                >
                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: 12,
                      textTransform: 'uppercase',
                      fontWeight: selectedLanguage.code === languageOption.code ? 'bold' : 'normal',

                    }}
                  >
                    {languageOption.code.substring(0, 2)}
                  </Typography>
                </Stack>
              </Box>
            ))
          }
        </>
      }
    </Stack>
  );

  let languageSwitcher = defaultLanguageSwitcher;

  if (variant === 'compact') {
    languageSwitcher = compactLanguageSwitcher;
  }

  return (
    <Box>
      {languageSwitcher}
    </Box>
  );
}
